module.exports = __webpack_public_path__ + "assets/img/ring.0d5c0ce7.svg";